module.exports = __webpack_public_path__ + "static/media/IMG_4167-min.5b6e46c1.JPG";